import { ReactNode } from 'react';
import { OverlayTrigger, Popover, Tooltip } from "react-bootstrap";
import { NCSGridHeader, GridHeaderMap } from "./ncs-grid-headers";
import SortableHeaderComponent from "@nkr/views/admin/center/list/common/sortable-header";
import { IHeaderParams } from 'ag-grid-community';
import PopoverTemplate from '@nkr/components/popover-template';
import styled from 'styled-components';

interface IProps {
  header: NCSGridHeader;
  children: ReactNode;
};

type TProps = IProps & IHeaderParams; 

export const PopoverWrapper = styled(Popover) <{ width?: string }>`
    max-width: ${p => p.width ? p.width : '600px'};
    
    & > div {
        font-size: 12px;
    }
`;

export const overlay = (title: string, description: string) => (
    <PopoverWrapper>
        <div><strong>{title}</strong></div>
        <div>{description}</div>
    </PopoverWrapper>
);

const HeaderHoverOver = ({ header, children, ...params } : TProps) => {
    const { title, description } = GridHeaderMap[header];

    return (
        <OverlayTrigger
            trigger={['hover', 'focus']}
            placement={'bottom'}
            rootClose
            overlay={overlay(title, description)}
        >
            <span style={{ display: 'inline-flex' }}>
                <SortableHeaderComponent {...params}>
                    {children}
                </SortableHeaderComponent>
            </span>
        </OverlayTrigger>
    )
}

export default HeaderHoverOver;